module.exports = __webpack_public_path__ + "media/images/star-2-24d9f75f31e2b308c8db5218ea154f4f.png";